export default [
    'exercise',
    'art',
    'fashion',
    'wine',
    'philanthropy',
    'politics',
    'boating',
    'cars',
    'sports',
    'reading',
    'foodie',
    'hunting',
    'gaming',
    'technology',
    'dogs',
    'cats',
    'socializing',
    'photography',
    'dancing',
    'gardening',
]